import type { JSX } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, RouteProps, Redirect } from 'wouter';
import { LOGIN } from './paths';
import { saveNextPage } from '~/components/context';
import { Actions as AuthActions } from '~/store/auth/actions';
import { isVerified } from '~/store/auth/selectors';
import { isLoggedIn } from '~/store/login/selectors';

const AuthRoute = (props: RouteProps): JSX.Element => {
  const verified = useSelector(isVerified);
  const loggedIn = useSelector(isLoggedIn);
  const dispatch = useDispatch();
  if (!verified) {
    if (loggedIn) {
      dispatch(AuthActions.VERIFY_REQUEST());
      return <>Verifying Account</>;
    }
    const nextPage = props.path;
    if (typeof nextPage === 'string') {
      saveNextPage(nextPage);
    }
    return <Redirect to={LOGIN} />;
  }
  return <Route {...props} />;
};

export default AuthRoute;
